import { render, staticRenderFns } from "./TixLegend.vue?vue&type=template&id=650206bf"
import script from "./TixLegend.vue?vue&type=script&lang=ts"
export * from "./TixLegend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports